/**
 * @fileoverview Modal component for viewing production order details
 * Displays production order information in a read-only view
 */
import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { intl, fetchData, HTTP_STATUS } from "dmsbasereact";
import { DmsDetailModal } from "../../DmsDetailModal";
import { ViewModeContent } from "./ViewModeContent";

/**
 * Modal for viewing production order details (read-only)
 */
export const ProductionOrderDetailModal = ({
  open,
  onClose,
  productionOrder = null,
}) => {
  const [loading, setLoading] = useState(false);
  const [enrichedOrder, setEnrichedOrder] = useState(null);

  // Load additional production order data if needed
  const loadAdditionalData = useCallback(async (orderData) => {
    if (!orderData) return null;

    try {
      // Fetch full production order details
      const response = await fetchData(
        `/production_order/${orderData.pk}`,
        "GET",
        true
      );
      
      if (response.status === HTTP_STATUS.OK_200 && response.data?.data) {
        return response.data.data;
      }
    } catch (error) {
      console.error("Error loading production order details:", error);
    }

    return orderData;
  }, []);

  // Load data when modal opens or production order changes
  useEffect(() => {
    if (open && productionOrder) {
      setLoading(true);
      loadAdditionalData(productionOrder).then((enriched) => {
        setEnrichedOrder(enriched);
        setLoading(false);
      });
    } else if (!open) {
      setEnrichedOrder(null);
    }
  }, [open, productionOrder, loadAdditionalData]);

  return (
    <DmsDetailModal
      open={open}
      onClose={onClose}
      data={enrichedOrder}
      loading={loading}
      title={{
        view: intl.get("ProductionOrderDetails").d("Production Order Details"),
      }}
      viewContent={ViewModeContent}
      canEdit={false}
    />
  );
};

ProductionOrderDetailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  productionOrder: PropTypes.object,
};

